import VacationDescriptionPresets from './vacationDescriptionPresets.container';

export { VacationDescriptionPresets };
